import React, { Fragment } from 'react'
import {Marker , Tooltip,Popup} from 'react-leaflet';
import {VenueLocationIcon} from './VenueLocationIcon';
import { highlightLocationIconMap } from './highlightLocationIconMap';
import { VenueLocationIconMap } from './VenueLocationIconMap';
import {highlightLocationIcon} from './highlightLocationIcon';
import MarkerPopup from './MarkerPopup';
import {Link} from 'react-router-dom'
import weatherDataPopup from './weatherDataPopup'
import ReactDOM from "react-dom";
import PolygonWithText from './PolygonWithText';
import { useState } from "react";
// import "./Modal/Modal.css";
// import Modal from 'react-bootstrap/Modal'
import 'bootstrap/dist/css/bootstrap.min.css'; 
import FlexboxPage from './flexBoard'
import Draggable from 'react-draggable';
import BasicTable from './yesterdayDataTable'
import   {useEffect } from "react";
import axios from 'axios';
import './styleFluxPopup.css';

import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';

import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import 'mdbreact/dist/css/mdb.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import { 

    Button, Modal, ModalFooter, 

    ModalHeader, ModalBody 

} from "reactstrap";
import { setHours } from 'date-fns';
import { set } from 'lodash';
// import Modal from './Modal/Modal'

// var Iframe = React.createClass({     
//   render: function() {
//     return(         
//       <div>          
//         <iframe src={this.props.src} height={this.props.height} width={this.props.width}/>         
//       </div>
//     )
//   }
// });

// ReactDOM.render(
//   <Iframe src="http://plnkr.co/" height="500" width="500"/>,
//   document.getElementById('example')
// );
const handleClick = (n) => {
  // window.open("https://bhuvan-staging1.nrsc.gov.in/nhp_flux/index.php?tower_id=" + n);
  // window.open('http://kanishkkunal.com','popup','width=600,height=600,scrollbars=no,resizable=no');
  return(<Popup maxWidth="1000" maxHeight="auto">
    <iframe src="https://www.youtube.com/embed/uXWycyeTeCs" width={1000} height={500} ></iframe>
  </Popup>);
//  weatherDataPopup();
  // <weatherDataPopup />
}

const VenueMarkers = (props) => {
  const position = [17.3261919,78.3957014];
  const[s, setStyle] = useState(null);
  const [coord, setPosition] = useState([]);
  const [high, setHigh] = useState([]);
  const [highLon, setHighLon] = useState([]);
  const [highLat, setHighLat] = useState([]);
  const[modal, setModal] = React.useState(false);
  const[name, setName] = React.useState('');
  const[mark, setMark] = React.useState('');
  const[tow_id, settowId] = React.useState('');
  const[geom,setGeom] = React.useState(null);
  const[post,setPost] = React.useState(null);
  const[at,setAt] = React.useState(null);
  const[rh,setRh] = React.useState(null);
  const[ts,setTs] = React.useState(null);
  const[nr,setNr] = React.useState(null);
  const[tsm,setTsm] = React.useState(null);
  const[mws,setMws] = React.useState(null);
  const[mwd,setMwd] = React.useState(null);
  const[tst,setTst] = React.useState(null);
  const[rain,setRain] = React.useState(null);
  const[lonD,setlonD] = React.useState(null);
  const[lonM,setlonM] = React.useState(null);
  const[lonS,setlonS] = React.useState(null);
  const[latD,setlatD] = React.useState(null);
  const[latM,setlatM] = React.useState(null);
  const[latS,setlatS] = React.useState(null);
  const[insT,setinsT] = React.useState(null);
  const[city,setCity] = React.useState(null);
  const[maxAt,setMaxAt] = React.useState(null);
  const[minAt,setMinAt] = React.useState(null);
  const[maxRh,setMaxRh] = React.useState(null);
  const[minRh,setMinRh] = React.useState(null);
  const[maxWs,setMaxWs] = React.useState(null);
  const[minWs,setMinWs] = React.useState(null);
  const[rainfall,setRainfall] = React.useState(null);
  const[tnr,setTnr] = React.useState(null);
  const[et,setEt] = React.useState(null);
  const[lon,setLon] = React.useState(null);
  const[instname,setInstName] = React.useState(null);
  const[idn,setIdn] = React.useState(1);

  const [isDragging, setIsDragging] = useState(false)

    const handleStart = () => {
         setIsDragging(true)
    }
    const handleStop = () => {
        setIsDragging(false)
    }
  const { venues } = props;
  const {layer} = props;
//  let high = ';'
const intervalRef = React.useRef(null);
var i;
let c = [];
const[arr,setArr] = React.useState([]);


  const removeMarker = (pos) => {
    setPosition((prevCoord) =>
      prevCoord.filter((coord) => JSON.stringify(coord) !== JSON.stringify(pos))
    );
  };


  const checkVenue = (props) =>
  {
    console.log(props);
    for(var i = 0;i<venues.length;i++)
    {
      if(venues[i].name == props)
      {
        setPosition([venues[i].geometry[0] , venues[i].geometry[1]]);
        setInstName(venues[i].description);
        break;
      }
    
    }
  };
  const handleClose = () =>
  {
    console.log("layer" , layer);
    setModal(!modal);
    setPosition([]);
    setIdn(idn+1);
    clearInterval(intervalRef.current);
    
  }
      const handleToggle = ev => {
       
      // console.log(ev.target.options.name);
      // alert(ev.target.options.name);
      // setId(ev.target.options.name);
      // setUrl(src);
     // alert(tow_id);
      // const { venues } = props;
        try{
      if(ev.target.options.name) {
        
        console.log(ev.target.options.description);
        
        setIdn(idn+1);
        settowId(ev.target.options.name);
        setInstName(ev.target.options.description);
        // console.log(ev.target.options.position);
        setGeom(ev.target.options.position);
        setPosition([ev.target.options.position[0] , ev.target.options.position[1]]);
        setLon({lonD} + {lonM}/60 + {lonS}/3600);
        setModal(!modal);
        
        
      }
    }
    catch(error)
    {} 
    
      
  
    };
    
    useEffect( () => {
      
      if(tow_id)
      {
        
      // axios.get('https://bhuvan.nrsc.gov.in/2dresources/nhp_flux/nhp_api.php?tower_id='+tow_id).then((response) => {
        axios.get('https://bhuvan.nrsc.gov.in/nhp_api/nhp_api.php?tower_id='+tow_id).then((response) => {
          // alert(tow_id);
        //  alert(response.data[0].Timestamp);
        if(response)
        {
          setPost(response.data);
          setAt(response.data[0].Air_Temperature);
          setRh(response.data[0].Relative_Humidity);
          setTs(response.data[0].Timestamp);
          setNr(response.data[0].Net_Radiation);
          setTsm(response.data[0].Top_Soil_Moisture);
          setMws(response.data[0].Mean_Wind_Speed);
          setMwd(response.data[0].Mean_Wind_Direction);
          setRain(response.data[0].Rain);
          setTst(response.data[0].Top_Soil_Temperature);
        }

        

     });

     
     axios.get('https://bhuvan.nrsc.gov.in/nhp_api/tower_details.php?tower_id='+tow_id).then((response) => {
      
        //  alert(response.data[0].Timestamp);
        //  setPost(response.data);
        //  
        if(response)
        {
          setlonD(response.data[0].Longitude_Deg);
          setlonM(response.data[0].Longitude_Min);
          setlonS(response.data[0].Longitude_Sec);
          setlatD(response.data[0].Latitude_Deg);
          setlatM(response.data[0].Latitude_Min);
          setlatS(response.data[0].Latitude_Sec);
          setinsT(response.data[0].Institute_Short);
          setCity(response.data[0].City);
        }


     });
     axios.get('https://bhuvan.nrsc.gov.in/nhp_api/yes_data.php?tower_id='+tow_id).then((response) => {
      
        //  alert(response.data[0].Timestamp);
        //  setPost(response.data);
        //  
        if(response)
        {
          setMaxAt(response.data[0].Max_Air_Temperature);
          setMinAt(response.data[0].Min_Air_Temperature);
          setMaxRh(response.data[0].Max_Relative_Humidity);
          setMinRh(response.data[0].Min_Relative_Humidity);
          setMaxWs(response.data[0].Max_Wind_Speed);
          setMinWs(response.data[0].Min_Wind_Speed);
          setRainfall(response.data[0].Rainfall);
          setTnr(response.data[0].Net_Radiation);
          setEt(response.data[0].Evaportransiration);
        }

     });
     clearInterval(intervalRef.current);
     intervalRef.current = setInterval( () => {axios.get('https://bhuvan.nrsc.gov.in/nhp_api/nhp_api.php?tower_id='+tow_id).then((response) => {
          // alert(tow_id);
        //  alert(response.data[0].Timestamp);
        //  setPost(response.data);
        if(response)
        {
          setAt(response.data[0].Air_Temperature);
          setRh(response.data[0].Relative_Humidity);
          setTs(response.data[0].Timestamp);
          setNr(response.data[0].Net_Radiation);
          setTsm(response.data[0].Top_Soil_Moisture);
          setMws(response.data[0].Mean_Wind_Speed);
          setMwd(response.data[0].Mean_Wind_Direction);
          setRain(response.data[0].Rain);
          setTst(response.data[0].Top_Soil_Temperature);
        }

        

     })} , 180000);
    
     
    }}, [tow_id]);

  const markers = venues.map((venue, index) => ( <>
    <Marker interactive={true} key={index} position={venue.geometry} description = {venue.description} name={venue.name} icon={layer === 'Map' ? VenueLocationIconMap : VenueLocationIcon} onClick={handleToggle} >
    
    
      {/* <MarkerPopup data={venue}/> */}
      {/* <PolygonWithText text="MyText" coords={venue.geometry} /> */}
        {/* <button className="btn-modal" onClick={toggleModal}>Click Here</button> */}
       <Tooltip  interactive={true}  direction="right" shadowSize="[0,0]" border="6px solid transparent"offset={[0, 0]} opacity={1} onClick={handleToggle} permanent >{venue.place}</Tooltip>
    </Marker>
    
    
     </>
  )); 
  
  // high = (coord.map((pos, idx) => (
  //   <Marker
  //     key={`marker-${idx}`}
  //     position={pos}
      
  //   >
      
  //   </Marker>
  // ))
  // );
  const modalStyles = {
    position: "fixed" ,
    top: "50%" ,
    left: "50%" ,
    transform: "translate(-50%, -50%) !important"
};

const class1 = window.innerWidth < 1200 ? 'd-flex align-items-end flex-column bd-highlight mb-3' : 'd-flex justify-content-between';

const class2 = window.innerWidth < 1200 ? 'd-flex align-items-end flex-column bd-highlight mb-3' : 'd-flex justify-content-center"';
  return( 
    <>
    
      <Fragment>{markers}</Fragment>

      {(coord.length != 0) ? 
     <Fragment><Marker
     key={`marker-1`}
     position={coord}
     icon = {highlightLocationIcon}
     
   >
     
   </Marker></Fragment>  : null


     } 
    {/* <div style={{ 

display: 'block', padding: 5

}}>  */}

<Draggable key={idn}>
<Modal className = "modal-flux" 
        show={true}
        size="lg" 
        //style={{marginTop:'10px' , maxWidth: '1000px', width: '90vw'}}
        isOpen={modal} scrollable={true} toggle={handleToggle}
        id="my-modal-test"

        >

    <ModalHeader 
        style = {{backgroundColor: '#255A5E'}}
        toggle={handleClose}><span class = "whiteTextBold">Tower details for: {instname}</span></ModalHeader> 

    <ModalBody id = "modalContent"  size="lg"
        show={true}>
    {/* { <iframe src={name}  width={750} height={500} ></iframe> } */}
   
    <div className="d-flex justify-content-center">
    <select class="btn " type="button" value={tow_id} id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
      onChange={(event) => { setStyle("custommodal"); settowId(event.target.value); checkVenue(event.target.value); }}>
  <option value="BPL">ICAR-CIAE, Bhopal</option>
  <option value="DWD">UAS, Dharwad</option>
  <option value="HYD">PJTSAU, Hyderabad</option>
  <option value="NGH">PAU, Naraingarh</option>
  <option value="PRJ">SHUATS, Prayagraj</option>
  <option value="PTN">GBPUAT, Pantnagar</option>
  <option value="PUN">VSI, Lonarwadi</option>
  <option value="RPR">IGKV, Raipur</option>
  <option value="OTY">ICAR-IISWC, Udhagamandalam</option>
  <option value="TDN">ORS TNAU, Tindivanam</option>
  
  </select>
  </div>
  
<div class="container my-4">
  <div id = "flex-head" class="d-flex justify-content-center" >
  <div class="p-2 flex-item bd-highlight" style={{borderLeft : 'solid black'}}><span class="whiteTextBold">Station: </span><span class="blueTextBold">{insT}, {city}</span></div>
  <div class="p-2 flex-item bd-highlight"><span class="whiteTextBold">Latitude: </span><span class="blueTextBold">{lonD}&#176; {lonM}' {lonS}''</span></div>
  <div class="p-2 flex-item bd-highlight"><span class="whiteTextBold">Longitude: </span><span class="blueTextBold">{latD}&#176; {latM}' {latS}''</span></div>
  <div class="p-2 flex-item bd-highlight"><span class="whiteTextBold">Date/Time: </span><span class="blueTextBold">{ts}</span></div>
  </div>
</div>
    {/* <p>{tow_id}</p> */}
    {/* <FlexboxPage data = {tow_id}/> */}
    <div className={class1}>
   <div class="container">
    <div className="d-flex justify-content-center my-4">
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Rainfall (</span><span class='yellowTextBold'>mm</span><span class='whiteTextBold'>)</span></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="p-2 weather_data_val col-example text-left">{rain}</div>
    </div>
    <div className="d-flex justify-content-between my-4">
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Relative Humidity ( </span><span class='yellowTextBold'>%</span><span class='whiteTextBold'>)</span></div>
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Air Temperature (</span><span class='yellowTextBold'>&#176;C</span><span class='whiteTextBold'>)</span></div>
    </div>
    <div className="d-flex justify-content-between">
      <div className="p-2 weather_data_val col-example text-left">{rh}</div>
      <div className="p-2 weather_data_val col-example text-left">{at}</div>
    </div>
    <div className="d-flex justify-content-around my-4">
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Mean Wind Speed (</span><span class='yellowTextBold'>m/s</span><span class='whiteTextBold'>)</span></div>
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Mean Wind Direction (</span><span class='yellowTextBold'>Deg</span><span class='whiteTextBold'>)</span></div>
    </div>
    <div className="d-flex justify-content-around">
      <div className="p-2 weather_data_val col-example text-left">{mws}</div>
      <div className="p-2 weather_data_val col-example text-left">{mwd}</div>
    </div>
    <div className="d-flex justify-content-center my-4">
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Net Radiation (</span><span class='yellowTextBold'>W m-2</span><span class='whiteTextBold'>)</span></div>
    </div>
    <div className="d-flex justify-content-center">
      <div className="p-2 weather_data_val col-example text-left">{nr}</div>
    </div>
    <div className="d-flex justify-content-between my-4">
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Top Soil Moisture (</span><span class='yellowTextBold'>%</span><span class='whiteTextBold'>)</span></div>
      <div className="p-2 weather_data col-example text-left"><span class='whiteTextBold'>Top Soil Temperature (</span><span class='yellowTextBold'>&#176;C</span><span class='whiteTextBold'>)</span></div>
    </div>
    <div className="d-flex justify-content-between">
      <div className="p-2 weather_data_val col-example text-left">{tsm}</div>
      <div className="p-2 weather_data_val col-example text-left">{tst}</div>
    </div>
    </div>
    <br/>
    <div class="d-flex justify-content-center">
    <MDBTable className = "text-nowrap table-sm  table table-bordered" autoWidth striped style={{backgroundColor: 'rgba(79, 121, 66,0.7)'}}>
      <MDBTableHead>
        <tr>
          <th class = "whiteTextBold">Yesterday's Weather</th>
          <th class = "whiteTextBold">Min.</th>
          <th class = "whiteTextBold">Max.</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>

          <td><span class="blackTextBold">Temperature (</span><span class = "yellowTextBold">&#176;C</span><span class="blackTextBold">)</span></td>
          <td class = "blackTextBold">{minAt}</td>
          <td class = "blackTextBold">{maxAt}</td>
        </tr>
        <tr>
          <td><span class="blackTextBold">Relative Humidity (</span><span class="yellowTextBold">%</span><span class="blackTextBold">)</span></td>
          <td class = "blackTextBold">{minRh}</td>
          <td class = "blackTextBold">{maxRh}</td>
        </tr>
        <tr>
          <td><span class="blackTextBold">Wind Speed (</span><span class="yellowTextBold">m/s</span><span class="blackTextBold">)</span></td>
          <td class = "blackTextBold">{minWs}</td>
          <td class = "blackTextBold">{maxWs}</td>
        </tr>
        <tr>
          <td><span class="blackTextBold">Rainfall (</span><span class="yellowTextBold">mm/day</span><span class="blackTextBold">)</span></td>
          <td class = "blackTextBold" colspan = "2">{rainfall}</td>
        </tr>
        <tr>
          <td class  = "w-auto "><span class="blackTextBold">Daily Net Radiation (</span><span class="yellowTextBold">W m-2</span><span class="blackTextBold">)</span></td>
          <td class = "blackTextBold" colspan = "2">{tnr}</td>
        </tr>
        <tr>
          <td><span class="blackTextBold">Evapotranspiration (</span><span class="yellowTextBold">mm/day</span><span class="blackTextBold">)</span></td>
          <td class = "blackTextBold" colspan = "2">{et}</td>
        </tr>
      </MDBTableBody>
    </MDBTable>
    </div>
  </div>
    </ModalBody>

</Modal> 
{/* <FlexboxPage /> */}
</Draggable>

{/* </div >  */}
    </>);
};

export default VenueMarkers;
